import React from 'react';
import { Form, Input, Header } from 'semantic-ui-react';
import { withFormik } from 'formik';
import yup from 'yup';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import Field from '../../../Field';

const ERROR_REQUIRED = 'This field is required';
const ERROR_NEGATIVE = "This field can't be negative";

const TransferForm = ({
  setFieldValue,
  label,
  values,
  errors,
  touched,
  handleChange,
  handleSubmit,
  isSubmitting,
  amountLabel,
  legalFeesLabel,
}) => {
  const handleDateChange = date => setFieldValue('date', date);
  const handleChangeRaw = e => e.preventDefault()

  return (
    <Form loading={isSubmitting} onSubmit={handleSubmit}>
      <Header as="h4">{label}</Header>
      <Form.Group>
        <Field
          error={errors && errors.amount}
          touched={touched && touched.amount}
        >
          <Form.Field>
            <Form.Input
              label={amountLabel || 'Amount *'}
              style={{ opacity: 1 }}
              name="amount"
              value={values.amount}
              placeholder="€"
              onChange={handleChange}
            />
          </Form.Field>
        </Field>
        {label === 'Transfer from Lawyer' && (
          <Field
            error={errors && errors.legalFees}
            touched={touched && touched.legalFees}
          >
            <Form.Field>
              <Form.Input
                label={legalFeesLabel}
                style={{ opacity: 1 }}
                name="legalFees"
                value={values.legalFees}
                placeholder="€"
                onChange={handleChange}
              />
            </Form.Field>
          </Field>
        )}
        <Field error={errors && errors.date} touched={touched && touched.date}>
          <Form.Field
            name="date"
            className="c-DatePicker__wrapper c-DatePicker__wrapper--filters"
          >
            <label>Date *</label>
            <DatePicker
              isClearable={false}
              showMonthDropdown
              showYearDropdown
              dateFormat="DD/MM/YYYY"
              selected={values.date}
              onChange={handleDateChange}
              onChangeRaw={handleChangeRaw}
              customInput={<Input style={{ width: '100%' }} />}
            />
          </Form.Field>
        </Field>
        <Form.Field>
          <label>
            <br />
          </label>
          <Form.Button color="blue" content="Save" />
        </Form.Field>
      </Form.Group>
    </Form>
  );
};

const formikConfig = {
  enableReinitialize: true,
  mapPropsToValues: props => {
    let fields = {
      amount: props.amount ? props.amount : 0,
      date: props.date ? moment(props.date) : moment()
    };
    if (props.label === 'Transfer from Lawyer') {
      fields = { ...fields, legalFees: props.legalFees ? props.legalFees : 0 };
    }
    return fields;
  },
  validationSchema: props => {
    let fields = {
      amount: yup
        .number()
        .required(ERROR_REQUIRED)
        .positive(ERROR_NEGATIVE)
        .typeError(ERROR_NEGATIVE),
      date: yup.string().required(ERROR_REQUIRED)
    };
    if (props.label === 'Transfer from Lawyer') {
      fields = {
        ...fields,
        legalFees: yup
          .number()
          .required(ERROR_REQUIRED)
          .positive(ERROR_NEGATIVE)
          .typeError(ERROR_NEGATIVE)
      };
    }
    return yup.object().shape(fields);
  },
  handleSubmit: (values, { props, setErrors, setSubmitting }) => {
    props.onSubmit(values, setSubmitting);
  }
};

export default withFormik(formikConfig)(TransferForm);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Compensation/TransferForm.js